module.exports = __webpack_public_path__ + "img/banner4.1dfc45ca.jpg";